export default "__VITE_ASSET__62a93041__"